export default "__VITE_ASSET__WDFa0dXl__"